import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { CHAPTERS } from "../../data/content";

export const Manifesto = () => (
  <section
    id="soluciones"
    data-testid="manifesto-section"
    className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36"
  >
    <div className="grid lg:grid-cols-12 gap-6 items-end mb-16 md:mb-28">
      <div className="lg:col-span-8 lg:col-start-1">
        <Reveal>
          <div className="eyebrow text-accent mb-5">Cómo solucionamos tus problemas</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-ink leading-[0.92] tracking-tight text-4xl sm:text-5xl lg:text-[5.2rem]">
            Tres problemas comunes,
            <br />
            una respuesta botánica
          </h2>
        </Reveal>
      </div>
    </div>

    <div className="space-y-20 md:space-y-32">
      {CHAPTERS.map((c, i) => {
        const flip = i % 2 === 1;
        return (
          <div
            key={c.n}
            data-testid={`manifesto-chapter-${c.n}`}
            className="grid lg:grid-cols-12 gap-8 lg:gap-16 items-center"
          >
            {/* image */}
            <Reveal
              className={`lg:col-span-5 ${flip ? "lg:order-2 lg:col-start-8" : ""}`}
            >
              <div className="relative overflow-hidden rounded-2xl aspect-[4/5] group">
                <motion.img
                  src={c.img}
                  alt={c.title}
                  className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                />
              </div>
            </Reveal>

            {/* text */}
            <div className={`lg:col-span-6 ${flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
              <Reveal>
                <div className="font-serif text-[6rem] md:text-[9rem] leading-none text-mutedbg select-none -mb-6 md:-mb-10">
                  {c.n}
                </div>
              </Reveal>
              <Reveal delay={0.1}>
                <h3 className="font-serif font-light text-ink text-4xl md:text-5xl mb-5 tracking-tight">
                  {c.title}
                </h3>
              </Reveal>
              <Reveal delay={0.18}>
                <p className="text-base md:text-lg text-ink/70 leading-relaxed max-w-md">
                  {c.body}
                </p>
              </Reveal>
            </div>
          </div>
        );
      })}
    </div>
  </section>
);
